"use client";

import type { QueryBlogIndexPageDataResult } from "@/lib/sanity/sanity.types";
import { BlogCard } from "@/components/blog-card";

type Blog = NonNullable<
  NonNullable<QueryBlogIndexPageDataResult>["blogs"]
>[number];

interface BlogClientWrapperProps {
  blogs: Blog[];
}

export function BlogClientWrapper({ blogs }: BlogClientWrapperProps) {
  return (
    <>
      {/* Blog Grid - 3 columns */}
      {blogs.length > 0 ? (
        <div className="grid grid-cols-1 gap-x-8 gap-y-12 md:grid-cols-2 lg:grid-cols-3">
          {blogs.map((blog) => (
            <BlogCard blog={blog} key={blog._id} />
          ))}
        </div>
      ) : (
        <div className="py-20 text-center">
          <p className="text-gray-600">
            No blog posts found matching your criteria.
          </p>
        </div>
      )}
    </>
  );
}
